import { render, staticRenderFns } from "./calendar-facet-weekdays-bgcolor.vue?vue&type=template&id=36257172&"
import script from "./calendar-facet-weekdays-bgcolor.vue?vue&type=script&lang=js&"
export * from "./calendar-facet-weekdays-bgcolor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports